// extracted by mini-css-extract-plugin
export var dividerLine = "_6j-3";
export var itemImage = "_6j-9";
export var lightDivider = "_6j-4";
export var modalContent = "_6j-5";
export var modalContentCompact = "_6j-6";
export var productCard = "_6j-a";
export var productImage = "_6j-b";
export var productImageCompact = "_6j-7";
export var productImagePlaceholder = "_6j-c";
export var productImagePlaceholderCompact = "_6j-8";
export var progressBarBackground = "_6j-1";
export var progressBarContainer = "_6j-0";
export var progressBarFill = "_6j-2";